export default {
    confirmSaveModal: {
        title: 'Potrdi shranjevanje',
        totalVolume: 'Skupna količina (vsota intervalov):',
        daysWithEdits: 'Dni s spremembami od zadnjega shranjevanja: {count}',
        atomicWrite: 'To je atomarni zapis — vseh {count} vrednosti intervalov bo shranjenih v eni transakciji.',
        saving: 'Shranjevanje...',
        confirmSave: 'Potrdi in shrani',
        saveFailed: 'Shranjevanje ni uspelo',
        notLoaded: 'Pogodba ni naložena — osvežite in poskusite znova.',
        savedToast: 'Shranjeno {count} dni · {volume}',
    },
}
